export default "__VITE_ASSET__D39vt9jn__"